import { Fields as Location } from 'models/Location'

export const getLabel = (location: Location | null) =>
  location ? `${location.street}, ${location.city}, ${location.state}` : ''
